module.exports = __webpack_public_path__ + "static/media/emptyBerry.7ef434be.svg";